var __templateData = Handlebars.template({"1":function(depth0,helpers,partials,data) {
  var helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;
  return "<div class=\"support\">\n  <h2>"
    + escapeExpression(((helpers.i18n || (depth0 && depth0.i18n) || helperMissing).call(depth0, "support_section", {"name":"i18n","hash":{},"data":data})))
    + "</h2>\n  <menu type=\"toolbar\">\n    <li><button class=\"guide\">"
    + escapeExpression(((helpers.i18n || (depth0 && depth0.i18n) || helperMissing).call(depth0, "guide", {"name":"i18n","hash":{},"data":data})))
    + "</button></li>\n    <li><button class=\"tutorials\">"
    + escapeExpression(((helpers.i18n || (depth0 && depth0.i18n) || helperMissing).call(depth0, "tutorials", {"name":"i18n","hash":{},"data":data})))
    + "</button></li>\n  </menu>\n</div>\n<div class=\"learn\">\n  <h2>"
    + escapeExpression(((helpers.i18n || (depth0 && depth0.i18n) || helperMissing).call(depth0, "learn_section", {"name":"i18n","hash":{},"data":data})))
    + "</h2>\n  <menu type=\"toolbar\">\n    <li><button class=\"group\">\n            <a target=\"_blank\" href=\"http://www.gradeworkinggroup.org\">"
    + escapeExpression(((helpers.i18n || (depth0 && depth0.i18n) || helperMissing).call(depth0, "group", {"name":"i18n","hash":{},"data":data})))
    + "</a>\n        </button>\n    </li>\n    <li><button class=\"handbook\">"
    + escapeExpression(((helpers.i18n || (depth0 && depth0.i18n) || helperMissing).call(depth0, "handbook", {"name":"i18n","hash":{},"data":data})))
    + "</button></li>\n    <li><button class=\"diagram\">"
    + escapeExpression(((helpers.i18n || (depth0 && depth0.i18n) || helperMissing).call(depth0, "diagram", {"name":"i18n","hash":{},"data":data})))
    + "</button></li>\n  </menu>\n</div>\n<div class=\"capabilities\">\n  <h2>"
    + escapeExpression(((helpers.i18n || (depth0 && depth0.i18n) || helperMissing).call(depth0, "capabilities_section", {"name":"i18n","hash":{},"data":data})))
    + "</h2>\n  <div id=\"capabilities\"></div>\n</div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var stack1, helperMissing=helpers.helperMissing, buffer = "";
  stack1 = ((helpers.i18nNamespace || (depth0 && depth0.i18nNamespace) || helperMissing).call(depth0, "projects:welcome.learn_section", {"name":"i18nNamespace","hash":{},"fn":this.program(1, data),"inverse":this.noop,"data":data}));
  if (stack1 != null) { buffer += stack1; }
  return buffer;
},"useData":true});
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}